import {
  EcgLeads,
  EcgMeasurements,
  ElectrodesStatus,
  GetEcgPermissionsDto,
  Symptom,
} from "../api/index.defs";
import { IBaseEcg } from "./base-ecg.interface";
import { IDynamicData } from "./dynamic-data.interface";

export interface IEcg extends IBaseEcg, IEcgDetails {
  minutesRemaining?: number;
  isReviewed?: boolean;
}

export enum EcgReviewState {
  NA = -1,
  Unreadable = 0,
  GraphOnly = 1,
  MokedReviewInProcess = 2,
  ReviewedByMoked = 3,
  ECRReviewInProcess = 4,
  ReviewedByECR = 5,
  ReviewedByCardiologist = 6
}

export interface IEcgDetails {
  id: string;
  date: string;
  reference?: string;
  deviceSerialNumber?: string;
  electrodesStatus?: ElectrodesStatus;
  measurements?: EcgMeasurements;
  symptoms?: Symptom[];
  permissions?: GetEcgPermissionsDto;
  findings?: IFindings[];
  actions?: IAction[];
  actionsReviewNote?: string;
  comments?: string;
  notes?: Note[];
  newNote?: string;
  interpretation?: Interpretation;
  graph?: EcgLeads;
  isReadable?: boolean;
  isUrgent?: boolean;
  saveOnce?: boolean;
  showSuggestive?: boolean;
  approval?: Approval;
  timeout?: number;
  hasPacemaker?: boolean;
  ecgReviewState?: EcgReviewState;
  isUnreadableBySystem?: boolean;
}

export interface IFindings extends IDynamicData {
  suggestiveOf?: string;
  useLeads?: boolean;
  leads?: ILead[];
  isEditable?: boolean;
}

export interface IAction extends IDynamicData {
  severity?: number;
}

export enum EcgActionSeverity {
  NA,
  Urgent,
  Important,
  Normal,
  Priority
}

export enum EcrOnDemandDataStates {
  NotAllowed,
  Disabled,
  Enabled,
}

export enum EcrOnDemandDataRejectReasons {
  None,
  EcgUnreadable,
  MokedReviewInProcess,
  EcrReviewInProcess,
  EcgAlreadyReviewedByECR,
  EcgAlreadyReviewedByCardiologist,
  MissingStateDefinition = 8,
  MissingReviewPermission,
  MissingLicensedReviewer,
}

export type UpdateEcg = {
  id: string;
  findings?: IFindings[];
  interpretation?: string;
  isReadable?: boolean;
  isUrgent?: boolean;
  actions?: IDynamicData[];
};

export interface IEcgsFilter {
  search?: string;
  unviewedOnly?: boolean;
  unInterpretedOnly?: boolean;
  sn?: string;
  fromDate?: string;
  toDate?: string;
  reviewPriorityNone?: boolean;
  reviewPriorityLow?: boolean;
  reviewPriorityHigh?: boolean;
  includeArchived?: boolean;
  uniqueId?: string;
}
export type ReviewPriority = "high" | "low" | "none";
export type UserRecord = {
  user: {
    id: string;
    display: string;
  };
  date: string;
};
export type UserTextRecord = { text: string } & UserRecord;
export type Approval = UserRecord;
export type Note = UserTextRecord;
export type Interpretation = UserTextRecord;

export interface ILead {
  code: number;
  value: boolean;
  name: string;
  disabled?: boolean;
}
export enum ReviewerActionsRequired {
  findingsOnly = 1,
  findingsAndInterpretations = 2,
}

export interface ILead {
  code: number;
  value: boolean;
  name: string;
}
